export enum QuotesErrors {
    UnKnown = 1000,
    UNAUTHORIZED = 401,
}

export class QuotesError {
    constructor(public errorCode: QuotesErrors, public message: string = '', public error: any = {}) {
    }

    get errorMessage(): string {
        return this.message ? this.message : this.statusMessage;
    }

    get statusMessage(): string {
        switch (this.errorCode) {
            case QuotesErrors.UNAUTHORIZED:
                return 'Please reload the page and login again.';
            default:
                return 'Unknown error';
        }
    }
}
